import { computed, observable, action, makeObservable, reaction } from 'mobx';
import { debounce } from 'debounce';
import agent from '../lib/agent';

class Store {
  threads = [];
  projectId = null;

  addMessageToThread = (threadId, messageOptions) => {
    const newThreads = [...this.threads];
    const threadIndex = newThreads.findIndex(thread => thread.id === threadId);
    if (threadIndex !== -1) {
      const id = `${Math.round(Math.random() * 900000)}`;
      newThreads[threadIndex].items.push({
        id,
        audience: messageOptions.audience,
        name: messageOptions.user.email,
        date: messageOptions.date || 'now',
        user: {
          name: messageOptions.user.email,
          id: messageOptions.user.id,
          email: messageOptions.user.email
        },
        group: {
          name: messageOptions.user.group.name,
          type: 'vendor',
          id: messageOptions.user.group.id
        },
        type: messageOptions.type,
        content: messageOptions.message
      });
    }
  };

  updateThread = async (threadId, updatedData) => {
    const newThreads = [...this.threads];

    const index = newThreads.findIndex(thread => thread.id === threadId);
    const thread = newThreads[index];
    newThreads[index] = {
      ...thread,
      image: updatedData.highlight.content.image,
      highlight: updatedData.highlight
    };

    // FIXME set image only for thread
    newThreads[index].items[0].image = updatedData.highlight.content.image;

    this.threads = newThreads;
  };

  addThread = async messageOptions => {
    const id = `${Math.random()}t_bla`;
    const date = `now`;

    const thread = {
      project_id: messageOptions.project_id,
      parent_id: messageOptions.parent_id,
      highlight: messageOptions.highlight,
      image: messageOptions.image,
      audience: messageOptions.audience,
      id,
      items: [
        {
          id: `${id}-item`,
          user: {
            name: messageOptions.user.email,
            id: messageOptions.user.id,
            email: messageOptions.user.email
          },
          name: messageOptions.user.email,
          date,
          group: messageOptions.user.group,
          type: messageOptions.type,
          content: messageOptions.message
        }
      ]
    };

    const newThreads = [...this.threads, thread];
    this.threads = newThreads;
    return id;
  };

  get issueCount() {
    return this.threads.filter(thread => !thread.closed).length;
  }

  resolveThread = threadId => {
    const newThreads = [...this.threads];
    const threadIndex = newThreads.findIndex(thread => thread.id === threadId);
    if (threadIndex !== -1) {
      newThreads[threadIndex].closed = Math.floor(new Date() / 1000);
      this.threads = newThreads;
    }
  };

  reset = () => {
    this.threads = [];
  };

  loadChat = async () => {
    if (this.projectId) {
      const response = await agent.Project.getChat(this.projectId);
      this.threads = response.data.data;
    }
  };

  update = async () => {
    await agent.Project.updateChat(this.projectId, this.threads);
  };

  setProjectId = async projectId => {
    this.projectId = projectId;
  };

  constructor() {
    makeObservable(this, {
      threads: observable,
      projectId: observable,
      addMessageToThread: action,
      resolveThread: action,
      issueCount: computed,
      addThread: action,
      update: action,
      reset: action,
      setProjectId: action
    });
  }
}

const store = new Store();

const debouncedUpdate = debounce(store.update, 200);

reaction(
  () => JSON.stringify(store.threads),
  () => {
    debouncedUpdate();
  }
);

reaction(
  () => `${store.projectId}`,
  () => {
    store.loadChat();
  }
);

export default store;
